import { PropsWithChildren } from 'react'
import { GamesNames, GamesRoute, GamesRoutes, GameType } from '../../constant'
import { TextLink } from './text-link'

interface Props {
  strong?: boolean
}

export function GamesLink({ children, ...props }: PropsWithChildren<PropsWithClass<Partial<Props>>>) {
  return (
    <TextLink href={GamesRoute} {...props}>
      {children}
    </TextLink>
  )
}

export const GameLink = ({
  game,
  children,
  ...props
}: PropsWithChildren<PropsWithChildren<Props & { game: GameType }>>) => {
  return (
    <TextLink href={GamesRoutes[game]} {...props}>
      {children || GamesNames[game]}
    </TextLink>
  )
}

export function SolitaireClashLink({ children, ...props }: PropsWithChildren<PropsWithClass<Pick<Props, 'strong'>>>) {
  return (
    <GameLink game={GameType.SolitaireClash} {...props}>
      {children}
    </GameLink>
  )
}

export function BingoClashLink({ children, ...props }: PropsWithChildren<PropsWithClass<Pick<Props, 'strong'>>>) {
  return (
    <GameLink game={GameType.BingoClash} {...props}>
      {children}
    </GameLink>
  )
}

export function BingoTourLink({ children, ...props }: PropsWithChildren<PropsWithClass<Pick<Props, 'strong'>>>) {
  return (
    <GameLink game={GameType.BingoTour} {...props}>
      {children}
    </GameLink>
  )
}

export function EightBallStrikeLink({ children, ...props }: PropsWithChildren<PropsWithClass<Pick<Props, 'strong'>>>) {
  return (
    <GameLink game={GameType.EightBallStrike} {...props}>
      {children}
    </GameLink>
  )
}

export function SolitaireVentureLink({ children, ...props }: PropsWithChildren<PropsWithClass<Pick<Props, 'strong'>>>) {
  return (
    <GameLink game={GameType.SolitaireVenture} {...props}>
      {children}
    </GameLink>
  )
}

export function Pocket7GamesLink({ children, ...props }: PropsWithChildren<PropsWithClass<Pick<Props, 'strong'>>>) {
  return (
    <GameLink game={GameType.Pocket7Games} {...props}>
      {children}
    </GameLink>
  )
}

export function BlockolotLink({ children, ...props }: PropsWithChildren<PropsWithClass<Pick<Props, 'strong'>>>) {
  return (
    <GameLink game={GameType.Blockolot} {...props}>
      {children}
    </GameLink>
  )
}

export function BubbleBuzzLink({ children, ...props }: PropsWithChildren<PropsWithClass<Pick<Props, 'strong'>>>) {
  return (
    <GameLink game={GameType.BubbleBuzz} {...props}>
      {children}
    </GameLink>
  )
}

export function CashPoolLink({ children, ...props }: PropsWithChildren<PropsWithClass<Pick<Props, 'strong'>>>) {
  return (
    <GameLink game={GameType.CashPool} {...props}>
      {children}
    </GameLink>
  )
}

export function SolitaireInfiniteLink({
  children,
  ...props
}: PropsWithChildren<PropsWithClass<Pick<Props, 'strong'>>>) {
  return (
    <GameLink game={GameType.SolitaireInfinite} {...props}>
      {children}
    </GameLink>
  )
}

export function SolitaireSlamLink({ children, ...props }: PropsWithChildren<PropsWithClass<Pick<Props, 'strong'>>>) {
  return (
    <GameLink game={GameType.SolitaireSlam} {...props}>
      {children}
    </GameLink>
  )
}

export function BingoBlissLink({ children, ...props }: PropsWithChildren<PropsWithClass<Pick<Props, 'strong'>>>) {
  return (
    <GameLink game={GameType.BingoBliss} {...props}>
      {children}
    </GameLink>
  )
}

export function MatchNFlipLink({ children, ...props }: PropsWithChildren<PropsWithClass<Pick<Props, 'strong'>>>) {
  return (
    <GameLink game={GameType.MatchNFlip} {...props}>
      {children}
    </GameLink>
  )
}

export function PlaySolitaireOnlineLink({
  children,
  ...props
}: PropsWithChildren<PropsWithClass<Pick<Props, 'strong'>>>) {
  return (
    <GameLink game={GameType.PlaySolitaireOnline} {...props}>
      {children}
    </GameLink>
  )
}

export function TwentyOneGoldLink({ children, ...props }: PropsWithChildren<PropsWithClass<Pick<Props, 'strong'>>>) {
  return (
    <GameLink game={GameType.TwentyOneGold} {...props}>
      {children}
    </GameLink>
  )
}

export function TileBlitzLink({ children, ...props }: PropsWithChildren<PropsWithClass<Pick<Props, 'strong'>>>) {
  return (
    <GameLink game={GameType.TileBlitz} {...props}>
      {children}
    </GameLink>
  )
}

export function NumbersBlitzLink({ children, ...props }: PropsWithChildren<PropsWithClass<Pick<Props, 'strong'>>>) {
  return (
    <GameLink game={GameType.NumbersBlitz} {...props}>
      {children}
    </GameLink>
  )
}

export function PoolClashLink({ children, ...props }: PropsWithChildren<PropsWithClass<Pick<Props, 'strong'>>>) {
  return (
    <GameLink game={GameType.PoolClash} {...props}>
      {children}
    </GameLink>
  )
}

export function DunkShotLink({ children, ...props }: PropsWithChildren<PropsWithClass<Pick<Props, 'strong'>>>) {
  return (
    <GameLink game={GameType.DunkShot} {...props}>
      {children}
    </GameLink>
  )
}

export function DominoesLink({ children, ...props }: PropsWithChildren<PropsWithClass<Pick<Props, 'strong'>>>) {
  return (
    <GameLink game={GameType.Dominoes} {...props}>
      {children}
    </GameLink>
  )
}
